<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Press Release</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/tonepress" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createPress" v-if="press">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-4" v-if="contentOrder.length">
                        <fg-select
                          v-model="press.contentOrder"
                          label="Release Type"
                          v-validate="rules.active"
                          data-vv-name="Release Type"
                          cus-name="Release Type"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="contentOrder"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-4">
                        <fg-input type="text"
                                  v-model="press.topicSubHead"
                                  label="Heading"
                                  placeholder="Enter Heading"
                                  v-validate="rules.topicSubHead"
                                  data-vv-name="Heading"
                                  cus-name="Heading"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-4">
                        <label>Published Date</label>
                        <datetime v-model="publishDate"
                                  required
                                  input-class="form-control"
                                  label="Published Date"
                                  placeholder="Select Date"
                                  type="date"
                                  input-format="DD-MM-YYYY"
                                  auto-continue>
                        </datetime>
                      </div>
                      <div class="col-12">
                        <fg-input type="text"
                                  v-model="press.topicSubHeadContents"
                                  label="Description"
                                  placeholder="Enter Description"
                                  v-validate="rules.topicSubHeadContents"
                                  data-vv-name="Description"
                                  cus-name="Description"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-9">
                        <fg-input type="text"
                                  v-model="press.pdfUrl"
                                  label="Link URL"
                                  placeholder="Enter URL"
                                  v-validate="rules.pdfUrl"
                                  data-vv-name="Link URL"
                                  cus-name="Link URL"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="press.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Press Release
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreatePress',
        created (){
    },
    data () {
      let dateTime = new Date();
        return {
            press: {
              topicHead: '',
              contentOrder: 2,
              topicSubHead: '',
              topicSubHeadContents: '',
              pdfUrl: '',
              active: '1',
              topicSubHeadDate: ''
            },
            active: 1,
            publishDate: dateTime.toISOString(),
            rules: {
              contentOrder: {required : true},
              topicSubHead: {required : true},
              topicSubHeadContents: {required : true},
              pdfUrl: {required : true},
              active: {required: true}
            },
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            contentOrder: [{id:"2", name:'Press Release'}, {id:"3", name:'In the News'}]
        }
    },
    methods: {
        createPress () {
          console.log("this.Press : ", this.press);
          this.press.topicSubHeadDate =  moment(this.publishDate).format('MM/DD/YYYY');
          this.press.topicHead = this.press.contentOrder === 2 ? 'Press Release': 'In the News'
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_PRESS', this.press)
                .then((res) => {
                  console.log("ADD_PRESS res : ", res);
                  if(res) this.showPopup('Success!', 'Press Release is successfully created', 'success', ()=>this.$router.push('/admin/tonepress'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_PRESS API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {

    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Press/CreatePress.vue